import { CircularProgress, Paper, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface LoadingCardProps {
  height?: number;
}

export const LoadingCard = ({ height = 200 }: LoadingCardProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        p: 2,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderLeft: '5px solid',
        borderColor: theme.palette.primary.main,
      }}
    >
      <CircularProgress aria-label={t('common.status.loading')} size={32} />
    </Paper>
  );
};
